import { render, staticRenderFns } from "./mediaslider-contentBlock.vue?vue&type=template&id=18daee76&scoped=true&"
import script from "./mediaslider-contentBlock.vue?vue&type=script&lang=js&"
export * from "./mediaslider-contentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18daee76",
  null
  
)

export default component.exports